import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux'

import DomainInput from '../domainstep/DomainInput'
import TopDomainListing from '../domainstep/TopDomainListing'
import AddedToCartListing from '../domainstep/AddedToCartListing'
import FurtherDomainListing from '../domainstep/FurtherDomainListing'
import StepControlButton, {CONTROL_NEXT, CONTROL_PREV} from '../../components/navigation/StepControlButton'
import {beginDomainCheck, queryInitialDomains, queryMoreDomains} from "../../actions/Domain";
import {ToggleSelection} from "../util/ToggleSelection";
import ToggleSelectionButtons from "../util/ToggleSelectionButtons";
import ToggleButton, {THEME_BLOCK_DESCRIPTION} from "../../components/ToggleButton";
import {APP_MODE_AGENCYSERVER_ADD_PROJECT, DOMAIN_TYPE_CUSTOM, DOMAIN_TYPE_DEV} from "../../constants/General";
import ToggleSelectionContents from "../util/ToggleSelectionContents";
import FloatingContent from "../../components/FloatingContent";
import {removeAllDomainsFromCart} from "../../actions/Cart";
import {getRemainingInclusiveDomains} from "../../selectors/Cart";
import {getBaseArticle, getCartTesting} from "../../selectors/SimpleSelectors";
import {delve} from "../../util/util";
import {agencyServerArticleNumber} from "../../config/Config";
import {isMode} from "../../selectors/Mode";

function DomainStep(props) {

    return (
        <div className="step-display__page domain-step">
            <h1>Domain auswählen</h1>
            <ToggleSelection
                id="domainType"
                onSelect={(target) => {
                    if (target === DOMAIN_TYPE_DEV) {
                        props.removeDomains();
                    }
                }}
            >
                <ToggleSelectionButtons>
                    <ToggleButton
                        icon={false}
                        target={DOMAIN_TYPE_DEV}
                        buttonLabel={"Kostenlose URL"}
                        theme={THEME_BLOCK_DESCRIPTION}
                        description={"Du weißt noch nicht, wie deine Domain heißen soll? Kein Problem. Jedes Projekt bei uns erhält automatisch eine kostenlose Projekt-URL (z.B. p*****.webspaceconfig.de). Damit kannst du auch von extern auf dein Projekt zugreifen und bist bestens für Tests gewappnet."}
                        hint={"kostenlos"}
                    />
                    <ToggleButton
                        disabled={props.isCartTesting}
                        disabledTooltip={"Während des 10-tägigen Testzeitraums können keine Wunschdomains ausgewählt werden. Du kannst deine Wunschdomain mit Beendigung des Tests nachträglich im Kundencenter hinzubuchen."}
                        icon={false}
                        target={DOMAIN_TYPE_CUSTOM}
                        buttonLabel={"Kostenpflichtige Wunschdomain"}
                        theme={THEME_BLOCK_DESCRIPTION}
                        description={"Prüfe und bestelle deine Wunschdomain zum Projekt. Weitere Domains kannst du jederzeit im Kundencenter hinzubuchen."}
                        hint={props.inclusiveDomains > 0 ? "ab 0.00 € mtl.*" : ("" + delve(props.baseArticle, "articleNumber") === agencyServerArticleNumber || isMode(APP_MODE_AGENCYSERVER_ADD_PROJECT) ? "ab 0.89 € mtl.*" : "ab 1.50 € mtl.*")}
                    />
                </ToggleSelectionButtons>
                <ToggleSelectionContents>
                    <FloatingContent key={DOMAIN_TYPE_DEV}>
                    </FloatingContent>
                    <FloatingContent key={DOMAIN_TYPE_CUSTOM}>
                        <DomainInput onFormSubmit={props.beginDomainCheck}/>
                        <AddedToCartListing/>
                        <TopDomainListing/>
                        <FurtherDomainListing onLoadMoreClick={props.loadMoreDomains}/>
                        {props.queriedDomain ? <p className="domain-step__hint">
                            Der Abrechnungszeitraum bei Domainbestellungen beträgt 12 Monate.
                        </p> : null}
                    </FloatingContent>
                </ToggleSelectionContents>
            </ToggleSelection>
            <div className="step-display__page__control">
                {props.prevLabel !== "" ? <StepControlButton type={CONTROL_PREV} label={props.prevLabel} onClick={props.onButtonPrevClick}/> : null}
                {props.nextLabel !== "" ? <StepControlButton type={CONTROL_NEXT} label={props.nextLabel} onClick={props.onButtonNextClick}/> : null}
            </div>
        </div>
    );

}

DomainStep.propTypes = {
    stepLabel: PropTypes.string.isRequired,
    nextLabel: PropTypes.string.isRequired,
    prevLabel: PropTypes.string.isRequired,
    onButtonNextClick: PropTypes.func,
    onButtonPrevClick: PropTypes.func,
    loadMoreDomains: PropTypes.func.isRequired,
    beginDomainCheck: PropTypes.func.isRequired
};


const mapStateToProps = (state) => {

    return {
        queriedDomain: state.domainCheck.queriedDomain,
        isCartTesting: getCartTesting(state),
        baseArticle: getBaseArticle(state),
        inclusiveDomains: getRemainingInclusiveDomains(state)
    }

}

const mapDispatchToProps = (dispatch) => {

    return {
        loadMoreDomains: () => {
            dispatch(queryMoreDomains())
        },
        removeDomains: () => {
          dispatch(removeAllDomainsFromCart())
        },
        beginDomainCheck: () => {
            dispatch(beginDomainCheck())
            dispatch(queryInitialDomains())
        }
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(DomainStep)



/** WEBPACK FOOTER **
 ** ./src/containers/domainstep/DomainStep.js
 **/